// ============================================================================
// The header bell — news only (item #650, TCSD-0189 rulings 6–7).
//
// A grey dot when there is unread news on the things you follow, and a tap
// opens yesterday's list. It never shows a count: the red number on My Work is
// the only count, and it is work, never news.
//
// The previous bell (interruptive-unread panel) stays in the repo, unrouted,
// for one release. Its rule that opening a panel must not mark WORK read still
// holds — nothing here touches a work row. News is marked read when the person
// opens the news list, which is the only way the dot can mean anything.
// ============================================================================
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useMyNews, useNewsPrefs } from '../modules/my-work/news';

export default function NewsBell() {
  const prefs = useNewsPrefs();
  const { items } = useMyNews(prefs.cadence, prefs.loaded && prefs.cadence !== 'off');
  const unread = items.some((i) => !i.read_at);
  return (
    <Link
      to="/my-work/news"
      aria-label={unread ? 'News — unread' : 'News'}
      className="relative grid h-11 w-11 place-items-center rounded-md text-tcs-text-secondary hover:bg-tcs-bg-muted"
    >
      <Bell className="h-5 w-5" />
      {unread && <span className="absolute right-2.5 top-2.5 h-2.5 w-2.5 rounded-full bg-tcs-text-muted" />}
    </Link>
  );
}
